



































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import * as firebase from 'firebase/app';
import Post from '@/model/Post';
import AccessType from '@/model/AccessType';
import { COLLECTION_ORGANIZATIONS, COLLECTION_POSTS, COLLECTION_USERS } from '@/model/AppConstants';
import User from '@/model/User';
import Organization from '@/model/Organization';
import FirebaseUtil from '@/model/FirebaseUtil';
import { VueEditor } from 'vue2-editor';
import VueUploadMultipleImage from 'vue-upload-multiple-image';
import FontPicker from 'font-picker-vue';
import PostTile from '@/model/PostTile';
import PostType from '@/model/typelist/PostType';

@Component({
  components: {
    VueEditor,
    VueUploadMultipleImage,
    FontPicker,
  },
})
export default class PostComponent extends Vue {
  @Prop({ type: Object }) post!: any;

  files = [] as any;

  photoURL = '';

  images = [] as any;

  compImages = [] as any;

  dialog= false;

  // color='';

  filename= '';

  dragtext= 'clcik me';

  browseText= '';

  items = [AccessType.publicType, AccessType.privateType];

  apiKey = 'AIzaSyDu0fPrikYBPQ2cPC_2hd71H64yEDGLQyI';

  defaultFont = 'Roboto';

  loading = false;

  options = {
    families: [
      'Pacifico',
      'Suranna',
      'Dancing Script',
      'Shadows Into Light',
      'Lobster',
      'Anton',
      'Indie Flower',
      'Charmonman',
      'Kodchasan',
      'Notable',
      'Mali',
      'Roboto',
      'Srisakdi',
      'Slabo 27px',
      'Timmana',
      'Lakki Reddy',
      'Ravi Prakash',
      'Dhurjati',
    ],
  };

  activeFont = this.defaultFont;

  $refs!: {
    fileInput: HTMLFormElement;
    canvas: HTMLCanvasElement;
  }

  customToolbar = [
    [{ font: [] }],
    [{ header: [false, 1, 2, 3, 4, 5, 6] }],
    ['bold', 'italic', 'underline', 'strike'],
    [
      { align: '' },
      { align: 'center' },
      { align: 'right' },
      { align: 'justify' },
    ],
    [{ header: 1 }, { header: 2 }],
    ['blockquote', 'code-block'],
    [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
    [{ script: 'sub' }, { script: 'super' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ color: [] }, { background: [] }],
    ['link'],
    [{ direction: 'rtl' }],
    ['clean'],
  ];
  // eslint-disable-next-line
  uploadImageSuccess(formData: any, index: any, fileList: any) {
    this.files = fileList;
  }
  // eslint-disable-next-line
  beforeRemove(index: any, done: any, fileList: any) {
    const r = true;
    if (r === true) {
      done();
    }
  }
  // eslint-disable-next-line
  editImage (formData: any, index: any, fileList: any) {
  }

  // myFunc(selectedFont: any) {
  //   this.activeFont = selectedFont.family;
  //   (document.getElementById('ql-editor')as HTMLFormElement).style.fontFamily = this.activeFont;
  // }

  // bgImg() {
  //   (document.getElementById('ql-editor')as HTMLFormElement).style.backgroundColor = this.color;
  // }

  async updatePost() {
    const postObj = { ...this.post };
    postObj.id = this.post.id;
    // postObj.postTile.bgColor = this.color;
    // postObj.postTile.fontFamily = this.activeFont;
    postObj.createdBy = FirebaseUtil.ObjectToRef(COLLECTION_USERS, this.post.createdBy.uid);
    const postCmts = [] as any;
    this.post.comments.forEach((cmt: any) => {
      const cmtObj = { ...cmt };
      cmtObj.createdTime = cmt.createdTime;
      cmtObj.createdBy = FirebaseUtil.ObjectToRef(COLLECTION_USERS, cmt.createdBy.uid);
      cmtObj.text = cmt.text;
      postCmts.push(cmtObj);
    });
    postObj.comments = postCmts;
    const photoURLs = await this.loadImages(this.post.id);
    photoURLs.forEach((p: any) => {
      postObj.photoURLList.push(p);
    });
    const abcd = await this.$store.dispatch('updateCollection', {
      collection: COLLECTION_POSTS,
      doc: this.post.id,
      payload: { ...postObj },
    });
    this.close();
  }

  async loadImages(postID: string) {
    const promiseArray = [] as any; // create an array for promises
    const imageArray = [] as any; // array for the images
    this.files.forEach((imageUrl: any) => {
      promiseArray.push(new Promise((resolve: any) => {
        const profileImageRef = firebase.storage().ref().child(`${postID}/${imageUrl.name}`);
        profileImageRef.putString(imageUrl.path, 'data_url')
          .then(() => {
            profileImageRef.getDownloadURL()
              .then((downloadURL: any) => {
                imageArray.push(downloadURL);
                resolve();
              });
          });
      }));
    });
    await Promise.all(promiseArray);
    return imageArray;
  }

  close() {
    this.dialog = false;
    this.photoURL = '';
    // this.post.content = '';
    this.images = [];
    this.files = [];
    // this.color = '';
    // this.bgImg();
  }

  get currentUser() {
    return this.$store.state.currentUser;
  }
}
